import { nitCheckDigit, nitDigits } from '@xiltrion/colombia';
import { Field, FieldLabel } from '@xiltrion/ui/field';
import { Input } from '@xiltrion/ui/input';

/** DV de un NIT, o vacío mientras no sea un NIT válido. */
export function nitDv(nit: string): string {
  const digits = nitDigits(nit);
  try {
    return digits ? String(nitCheckDigit(digits)) : '';
  } catch {
    return '';
  }
}

/** NIT con su dígito de verificación a la derecha, de solo lectura: lo calcula la suite. */
export function NitConDv({ id, value, onChange }: { id: string; value: string; onChange: (nit: string) => void }) {
  return (
    <div className="flex gap-2">
      <Field className="flex-1"><FieldLabel htmlFor={id}>NIT</FieldLabel><Input id={id} className="tnum" value={value} onChange={(e) => onChange(e.target.value)} placeholder="900123456" /></Field>
      <Field className="w-16"><FieldLabel htmlFor={`${id}-dv`}>DV</FieldLabel><Input id={`${id}-dv`} className="tnum text-center" readOnly disabled value={nitDv(value)} title="Dígito de verificación: lo calcula la suite" /></Field>
    </div>
  );
}
